module.exports = __webpack_public_path__ + "media/images/client/AssistantChat/avatar-1-8b1a64aa3ebb36b5d4cdde51250e15d6.png";